module.exports = __webpack_public_path__ + "f37b749983ddde30f243ff46547c21eb.fbx";